import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { PrVnta, ProductVntaService, PrVntaData } from '../../services/product-vnta.service';
import { ProductTypeService } from '../../services/product-type.service';
import { UnitService } from '../../services/unit.service';
import { ActivityService, ActivityId, PdfActivityDisplayLabels } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';

import { QuotationFunctionData } from '../../quotation-activity-functions';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-update-pr-vnta',
  templateUrl: './update-pr-vnta.component.html',
  styleUrls: ['./update-pr-vnta.component.css']
})
export class UpdatePrVntaComponent implements OnInit, OnDestroy {

  prTypeError: boolean = false;
  unitError: boolean = false;

  modalActionsCharac = new EventEmitter<string|MaterializeAction>();
  modalParams = [{dismissible: true}];

  prVntaForm: FormGroup;
  sectionForm: FormGroup;
  charactForm: FormGroup;
  activityForm: FormGroup;

  characs = [];

  sections: any[];
  currentSectionTab: number;
  currentSectionShowing: boolean;
  modalActionsSection = new EventEmitter<string|MaterializeAction>();
  modalParamsSection = [{dismissible: true}];

  generalActivities: any[];
  currentActivityEdit: number;
	unique: any = {
		papel: {prCmpaId: '', prCmpaDescription: ''}
	};
  uniqueInit = {
    papel: undefined
  }
  activityIsGeneral: boolean;
  activityFunction: any;
  activityDataCalc: string;
  pdfDisplay: ActivityId['pdfDisplay'] = this.activityService.defaultDisplay;
  activityRanges: any[];
  labels: string[];
  modalActionsActivity = new EventEmitter<string|MaterializeAction>();
  modalParamsActivity = [{dismissible: true}];

  prTypes = {};
  units = {};
  acts = {};
  activities = {};
  classifications = {};

  highestCode: string = '0000';

  sid: string;
  prVnta: any;

  prTypesInit: any;
  unitsInit: any;
  activitiesInit: any;
  activitiesInits: any;
  classificationInit: any;
  classificationInits: any;

  modalPurpose: string = 'add';

  activityFunctionDatas: any;
	generalfunctionSelects: any[];
	sectionfunctionSelects: any[];

  globalActions = new EventEmitter<string|MaterializeAction>();
  
  productSatKeySelect: any[] = [];
  unitSatKeySelect: any[] = [];

  subs: Subscription[] = [];

  Object = Object;
  PdfActivityDisplayLabels = PdfActivityDisplayLabels;
  constructor(
    private prVntaService: ProductVntaService,
    private prVntaData: PrVntaData,
    private prTypeService: ProductTypeService,
    private unitService: UnitService,
    private prCmpaService: ProductCmpaService,
    private activityService: ActivityService,
		private activityClassificationService: ActivityClassificationService,
    private quotationFunctionData: QuotationFunctionData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
    this.productSatKeySelect = Object.keys(prVntaData.productSatKeyObjects).map(key => ({
      value: key,
      ...prVntaData.productSatKeyObjects[key]
    }) );
    this.unitSatKeySelect = Object.keys(prVntaData.unitSatKeyObjects).map(key => ({
      value: key,
      ...prVntaData.unitSatKeyObjects[key]
    }) );

    this.sections = [];
    this.generalActivities = [];
    this.activityFunctionDatas = this.quotationFunctionData.functionData;
    this.activityFunction = {};
    this.generalfunctionSelects = [];
		this.sectionfunctionSelects = [];
		quotationFunctionData.selectArray.map(data => {
			if(data.isGeneral) this.generalfunctionSelects.push(data);
			else this.sectionfunctionSelects.push(data);
    })
    
    this.activities = {};
    this.activitiesInits = { 'section': {data: {}}, 'general': {data: {}}, };
    this.subs.push(
      this.activityService.getActivities().subscribe(activities => {
        const data = activities.reduce((acc, cur) => {
          const type = cur.activityClassObj.perSection ? 'section' : 'general';
          this.activitiesInits[type].data[`${cur.name.trim()}`] = null;
          this.activities[`${cur.name.trim()}`] = {
            ...cur,
            classification: cur.activityClassObj.name,
            quantityPricesFunction: cur.quantityPricesFunction || '',
            ranges: cur.ranges || [],
            prices: cur.prices || [],
            unique: cur.unique || {},
            pdfDisplay: cur.pdfDisplay || this.activityService.defaultDisplay,
            actId: cur.id
          };
          this.activities[`${cur.id}`] = this.activities[`${cur.name.trim()}`];
          return acc;
        }, {});
      })
    );

    this.classifications = {};
    this.classificationInits = { 'section': {data: {}}, 'general': {data: {}}, };
    this.subs.push(
      this.activityClassificationService.getActivityClassifications().subscribe(tempClassifications => {
        for (const idx in tempClassifications) {
          const type = tempClassifications[idx].perSection ? 'section' : 'general';
          this.classificationInits[type].data[`${tempClassifications[idx].name.trim()}`] = null;

          this.classifications[tempClassifications[idx].name] = { id: tempClassifications[idx].id$, isGeneral: !tempClassifications[idx].perSection };
          this.classifications[tempClassifications[idx].id$] = { name: tempClassifications[idx].name, isGeneral: !tempClassifications[idx].perSection };
        }
      })
    );

    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      let prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
        const data = prCmpas.reduce((acc, cur) => {
          cur.characs = cur.characs.reduce((acc2, cur2, index) => {
            let unit = units.find(({id}) => id == cur2.unitId.id);
            let symbol = unit ? unit.symbol : '';
            return acc2 + `${index ? ', ' : ''}${cur2.name}: ${cur2.value}${symbol}`;
          }, '');
          acc[`${cur.name} - ${cur.characs}`] = null;
          return acc;
        }, {});
        this.uniqueInit.papel = { 'data': data };
      });
      this.subs.push(prCmpasSub);
    });

    let sub = this.prVntaService.getPrVntas().subscribe(prVntas => {
      sub.unsubscribe();
      this.highestCode = prVntas.reduce((acc, cur) => {
        while(isNaN(cur.code[0])) cur.code = cur.code.substring(1);
        if(cur.code > acc && !isNaN(+cur.code)){
          let n = +cur.code;
          acc = cur.code.replace(`${n}`, `${n+1}`);
        }
        return acc;
      }, '0000');
    });
  }

  ngOnInit() {
    this.createForm();
    this.createSectionForm();
    this.createActivityForm();
    this.createCharacForm();
    this.subs.push(
      this.prTypeService.getPrVTypes().subscribe(prTypes => {
        const data = prTypes.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.prTypes[`${cur.name.trim()}`] = { id: cur.id, code: cur.code };
          return acc;
        }, {});
        this.prTypesInit = {
          'data': data
        };
      })
    );
    this.subs.push(
      this.unitService.getUnits().subscribe(units => {
        const data = units.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.units[`${cur.name.trim()}`] = cur.id;
          return acc;
        }, {});
        this.unitsInit = {
          'data': data
        };
      })
    );

    this.subs.push(
      this.prVntaService.getPrVnta(this.sid).subscribe(([{data: prType, ...data}]) => {
        this.prVnta = {prTypeId: prType.name, ...data};
        this.prVntaForm.patchValue(this.prVnta);

        this.sections = data.sections;
        this.generalActivities = data.generalActivities;
        data.characs.map(charac => {
          const unitRef = charac.unitId.path;
          const unit = this.prVntaService.getUnitDoc(unitRef);
          let subUnit = unit.subscribe(dataUnit => {
            charac.nameUnit = dataUnit.name;
            charac.unitId = charac.unitId.id;
            subUnit.unsubscribe();
          })
        });
        this.characs = data.characs;
      })
    );
  }

  ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm() {
    this.prVntaForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      code: '',
      prTypeId: ['', Validators.required],
      productSatKey: ['', Validators.required],
      unitSatKey: ['', Validators.required]
    });
  }
  createSectionForm() {
    this.sectionForm = this.fb.group({
      name: ['', Validators.required],
      width: ['', Validators.required],
      height: ['', Validators.required],
      sizeInPaper: ['', Validators.required],
      pieceInSize: ['', Validators.required],
      frontInk: ['', [Validators.required, Validators.max(8)]],
      backInk: ['', [Validators.required, Validators.max(8)]],
      sheetWidth: ['', Validators.required],
      sheetHeight: ['', Validators.required],
      numPages: ['', Validators.required],
      pieceHeight: ['', Validators.required],
      pieceLong: ['', Validators.required],
      pieceWidth: ['', Validators.required],
    })
  }
  createActivityForm() {
    this.activityForm = this.fb.group({
      name: ['', Validators.required],
			classification: ['', Validators.required],
      quantityPricesFunction: ['', Validators.required],
      prices: this.fb.array([]),
      minRange: '',
      maxRange: '',
      rangePrice: ''
    })
  }
	get qpFunction(){ return this.activityForm.get('quantityPricesFunction').value; }
  createCharacForm() {
    this.charactForm = this.fb.group({
      name: ['', Validators.required],
      value: ['', Validators.required],
      unitId: ['', Validators.required]
    });
  }

  addCharact({ value, valid }: { value: any, valid: boolean }) {
    value.nameUnit = value.unitId;
    value.unitId = this.units[value.unitId];
    if (value.unitId != undefined) {
      this.characs.push(value);
      this.closeCharactModal();
    } else {
      this.unitError = true;
      this.charactForm.get('unitId').reset();
    }
  }
  deleteCharact(index: number) {
    this.characs.splice(index, 1);
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.classnId = this.prTypes[value.prTypeId].id;
    value.characs = this.characs;
    value.sections = this.sections;
    value.generalActivities = this.generalActivities;
    value.name = value.name.trim();

    delete value.prTypeId;
    this.prVntaService.updatePrVnta(this.sid, value);
  }

  onChangeClass(name: string){
    let classn = this.prTypes[name];
    this.prTypeError = !classn;
    if(!this.prTypeError) this.prVntaForm.get('code').patchValue(`${classn.code}-${this.highestCode}`);
  }

  openCharactModal() {
    this.charactForm.reset();
    this.modalActionsCharac.emit({ action: 'modal', params: ['open'] });
  }
  closeCharactModal() {
    this.modalActionsCharac.emit({ action: 'modal', params: ['close'] });
  }

  //////////////////////////////////////////////////////////////////////////SECTION
  touchSection({ value, valid }: { value: any, valid: boolean }){
    if(this.modalPurpose == 'add'){
      this.sections.push(value); 
      value.activities = [];
    }else{
      value.activities = this.sections[this.currentSectionTab].activities;
      this.sections[this.currentSectionTab] = value;
    }
    this.closeModalSection();
  }
  removeSection(index) {
    this.sections.splice(index, 1);
  }
  changeSectionTab(index) {
    if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
    else{
      this.currentSectionTab = index;
      this.currentSectionShowing = true;
    }
  }
  openModalSection(action: string, index?: number) {
    this.modalPurpose = action;
    this.sectionForm.reset();
    if(action == 'edit'){
      this.currentSectionShowing = true;
      this.currentSectionTab = index;
      var section = this.sections[index];
      this.sectionForm.patchValue(section);
    }
    this.modalActionsSection.emit({ action: 'modal', params: ['open'] });
  }
  closeModalSection() {
    this.modalActionsSection.emit({ action: 'modal', params: ['close'] });
  }

  //////////////////////////////////////////////////////////////////////////ACTIVITY
  touchActivity({ value, valid }: { value: any, valid: boolean }) {
    var activity = value;
    activity.actId = this.currentActId;
    activity.dataCalc = this.activityDataCalc;
    activity.pdfDisplay = {...this.pdfDisplay};
    if(activity.dataCalc === 0){
      activity.ranges = this.activityRanges;
      activity.prices = [];
    }else if(activity.dataCalc > 0){
      activity.prices = value.prices.map(object => object.price);
      activity.ranges = [];
    }
    if(activity.quantityPricesFunction == 'papel') activity.unique = { prCmpaDescription: this.unique.papel.prCmpaDescription, prCmpaId: this.unique.papel.prCmpaId};
    delete activity.minRange;
    delete activity.maxRange;
    delete activity.rangePrice;

    if(this.activityIsGeneral){
      if(this.modalPurpose == 'add') this.generalActivities.push(activity);
      else this.generalActivities[this.currentActivityEdit] = activity;
    }else{
      //console.log(this.sections); // No borrar por favor :(
      if(this.modalPurpose == 'add') this.sections[this.currentSectionTab].activities.push(activity);
      else this.sections[this.currentSectionTab].activities[this.currentActivityEdit] = activity;
    }
    this.closeModalActivity();
    
  }
  removeActivity(isGeneral: boolean, index: number) {
    let acts = isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities;
    if(!confirm(`¿Borrar la actividad ${acts[index].name}?`)) return;
    acts.splice(index, 1);
  }

  openModalActivity(action: string, isGeneral: boolean, index?: number) {
    this.currentActId = '';
    while(this.prices.length > 0) this.prices.removeAt(0);
    this.modalPurpose = action;
    this.activityForm.reset();
    this.activityFunction = {};
    this.activityDataCalc = '';
    this.pdfDisplay = this.activityService.defaultDisplay;
    this.activityRanges = [];
    this.activityIsGeneral = isGeneral;
    const type = isGeneral ? 'general' : 'section';
    this.unique.papel.prCmpaDescription = '';
    this.unique.papel.prCmpaId = '';
    this.updateActivitiesInit(type);
    this.updateClassificationInit(type);
    if(action == 'edit'){
      this.currentActivityEdit = index;
      var activity = isGeneral ? this.generalActivities[index] : this.sections[this.currentSectionTab].activities[index];
      this.currentActId = activity.actId || '';
      this.activityDataCalc = activity.dataCalc;
      this.pdfDisplay = activity.pdfDisplay || this.activityService.defaultDisplay;
      this.activityForm.get('name').patchValue(activity.name);
      this.activityForm.get('classification').patchValue(activity.classification);
      this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
      this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaDescription = activity.unique && activity.unique.prCmpaDescription || '';
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaId = activity.unique && activity.unique.prCmpaId || '';
      this.activityRanges = activity.ranges;
      if(activity.dataCalc > 0){
        this.labels = this.activityFunction.labels;
        [...Array(this.quotationFunctionData.functionData[this.qpFunction].dataCalc)].map((u, index) => {
        //activity.prices.map(number => {
          this.prices.push(this.fb.group({price: activity.prices[index] || 0}));
        });
      }
    }else{
      if(this.activityIsGeneral) var array = this.generalfunctionSelects;
      else var array = this.sectionfunctionSelects;
      this.activityForm.get('quantityPricesFunction').patchValue(array[0].value);
      this.onChangeAFunction(array[0].value);
    }
    this.modalActionsActivity.emit({ action: 'modal', params: ['open'] });
  }
  closeModalActivity() {
    this.modalActionsActivity.emit({ action: 'modal', params: ['close'] });
  }

  updateActivitiesInit(type){
    this.activitiesInit = this.activitiesInits[type];
  }
  updateClassificationInit(type){
    this.classificationInit = this.classificationInits[type];
  }

  currentActId: string = '';
  onChangeAName(name){
    if(this.activities[name]){
      var activity = this.activities[name];
      this.currentActId = activity.actId;
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaDescription = activity.unique && activity.unique.prCmpaDescription || '';
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaId = activity.unique && activity.unique.prCmpaId || '';
      this.activityDataCalc = activity.dataCalc;
      this.pdfDisplay = activity.pdfDisplay || this.activityService.defaultDisplay;
      this.activityForm.get('classification').patchValue(activity.classification);
      this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
      this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
      this.activityRanges = activity.ranges;
      while(this.prices.length > 0) this.prices.removeAt(0);
      if(activity.dataCalc > 0){
        this.labels = this.activityFunction.labels;
        [...Array(this.quotationFunctionData.functionData[this.qpFunction].dataCalc)].map((u, index) => {
        //activity.prices.map(number => {
          this.prices.push(this.fb.group({price: activity.prices[index] || 0}));
        });
      }
    }
  }
  onChangeAFunction(functionName){
    this.activityFunction = this.activityFunctionDatas[functionName];
    this.activityDataCalc = this.activityFunction.dataCalc;
    while(this.prices.length > 0) this.prices.removeAt(0); //reset prices por pushing
		this.labels = this.activityFunction.labels;
		if(this.activityFunction.dataCalc > 0 ) for(var i = 0; i < this.activityFunction.dataCalc; i++) this.prices.push(this.priceForm());
  }

  touchActivityRange(){
    const min = Math.abs(+this.activityForm.get('minRange').value);
    const max = Math.abs(+this.activityForm.get('maxRange').value);
    const price = Math.abs(+this.activityForm.get('rangePrice').value);
    if(!isNaN(min) || !isNaN(max) || !isNaN(price)){
      this.activityRanges.push({
        min: min,
        max: max,
        price: price
      });
      this.activityForm.get('minRange').reset();
      this.activityForm.get('maxRange').reset();
      this.activityForm.get('rangePrice').reset();
    }
  }
  removeActivityRange(index){
    this.activityRanges.splice(index,1);
  }
  get prices(): FormArray {
		return this.activityForm.get('prices') as FormArray;
	}
	priceForm(){
		return this.fb.group({
			price: ['', Validators.required]
		});
	}


  money = Utils.money;

}




